export default "__VITE_ASSET__DCTa73tc__"